/* eslint-disable react/jsx-key */
import { Box, Button, IconButton, Tooltip } from '@mui/material';
import MetadataFieldSelector from '.';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import AddIcon from '@mui/icons-material/Add';
import { IMetadataJSON, MetadataTemplateMakerProps } from './types';
import { v4 as uuidv4 } from 'uuid';
import KeyboardDoubleArrowUpIcon from '@mui/icons-material/KeyboardDoubleArrowUp';
import KeyboardDoubleArrowDownIcon from '@mui/icons-material/KeyboardDoubleArrowDown';

function MultipleMetadataFields(props: MetadataTemplateMakerProps) {
  const {
    formFields = [],
    setFormFields,
    hideValues = false,
  } = props;


  function removeNthEl(arr: any[], i: number): any[] {
    return [
      ...arr.slice(0, i),
      ...arr.slice(i + 1)
    ];
  }

  const addFields = () => {
    setFormFields([...formFields, { propertyName: '', propertyType: '', propertyValue: '', key: uuidv4() }]);
  };

  const updateState = (metadata: IMetadataJSON, key: string) => {
    const index = formFields.findIndex((entry) => entry.key == key);
    if (index == -1) return;
    const newArray = [...formFields];
    newArray[index] = metadata;
    setFormFields(newArray);
  };


  const deleteEntry = (metadataEntry: IMetadataJSON) => {
    const key = metadataEntry.key;
    let newArray = [...formFields];
    const index = newArray.findIndex((entry) => entry.key == key);

    newArray = removeNthEl(newArray, index);
    setFormFields(newArray);
  };

  const handleUp = (key: string) => {

    const index = formFields.findIndex((entry) => entry.key == key);
    if (index == -1) return;
    if (index === 0) return;
    const newArray = [...formFields];
    const temp = newArray[index];
    newArray[index] = newArray[index - 1];
    newArray[index - 1] = temp;

    setFormFields(newArray);

  };
  const handleDown = (key: string) => {

    const index = formFields.findIndex((entry) => entry.key == key);
    if (index == -1) return;
    if (index === formFields.length - 1) return;
    const newArray = [...formFields];
    const temp = newArray[index];
    newArray[index] = newArray[index + 1];
    newArray[index + 1] = temp;
    setFormFields(JSON.parse(JSON.stringify(newArray)));

  };


  return (<>
    <Box display='flex' flexDirection='column'
      gap={5}>

      {formFields.map((metadataEntry, index) => {
        return <Box
          key={metadataEntry.key}
          display='flex'
          gap={5}>
          <MetadataFieldSelector
            hideValues={hideValues}
            metadata={metadataEntry}
            getMetadata={fieldMetadata => updateState(fieldMetadata, metadataEntry.key)}
          />

          <Tooltip title='Διαγραφή Πεδίου'>
            <IconButton onClick={() => deleteEntry(metadataEntry)}>
              <HighlightOffIcon color='error' />
            </IconButton>
          </Tooltip>

          {index !== 0 && <IconButton onClick={() =>
            handleUp(metadataEntry.key)}>
            <KeyboardDoubleArrowUpIcon />
          </IconButton>
          }
          {
            index < formFields.length - 1 && < IconButton onClick={() =>
              handleDown(metadataEntry.key)}>
              <KeyboardDoubleArrowDownIcon />
            </IconButton>
          }
        </Box>;

      })}

    </Box>

    <Box mt={3}>

      <Button variant='contained' onClick={addFields}
        startIcon={<AddIcon />}>Προσθήκη Πεδίου</Button>
    </Box>


  </>);
}

export default MultipleMetadataFields;